import { graphql, useStaticQuery } from 'gatsby';

export type ICampaignData = {
  config: {
    edges: {
      node: {
        content: any;
      };
    }[];
  };
};

const useSiteSettingsData = ({ pathname }: { pathname: string }) => {
  const settings = useStaticQuery(graphql`
    {
      config: allStoryblokEntry(
        filter: { field_component: { eq: "site-config" } }
      ) {
        edges {
          node {
            name
            uuid
            full_slug
            content
          }
        }
      }
    }
  `);

  // Determine currentPath based on pathname
  let currentPath;

  if (pathname === '/') {
    currentPath = ''; // Treat empty pathname as homepage
  } else {
    const firstFourChars = pathname.slice(0, 4);
    currentPath =
      firstFourChars.startsWith('/') && firstFourChars.endsWith('/')
        ? firstFourChars.slice(0, 3) // Use the first three characters
        : ''; // Use just '/'
  }

  // Filter for settings that match the current path
  const correctSetting = settings.config.edges.filter((edge: any) => {
    const content =
      typeof edge.node.content === 'string'
        ? JSON.parse(edge.node.content)
        : edge.node.content;

    // Check if currentPath is the same as content.slug
    return content.slug === currentPath;
  });

  // Parse the content
  const parsedSetting =
    correctSetting.length > 0
      ? JSON.parse(correctSetting[0].node.content)
      : undefined;

  return parsedSetting;
};

export default useSiteSettingsData;
